export const CANONICAL_HOST = "https://www.travelcarma.com";

export const canonicalUrl = (pathname = "/") => {
  const cleanPath = pathname === "/" ? "" : pathname.replace(/\/+$/, "");
  return `${CANONICAL_HOST}${cleanPath}`;
};
